import { create } from 'zustand';

type CollectionsDialogState = {
	open: boolean;
	openDialog: () => void;
	closeDialog: () => void;
};

const useCollectionsDialogStore = create<CollectionsDialogState>((set) => ({
	open: false,
	openDialog: () => set({ open: true }),
	closeDialog: () => set({ open: false }),
}));

export default useCollectionsDialogStore;
